export interface Team {
  name: string;
  captain: string;
  members: string[];
}

export interface DatesConfig {
  week: "FIRST" | "THIRD";
  months: (
    | "January"
    | "February"
    | "March"
    | "April"
    | "May"
    | "June"
    | "July"
    | "August"
    | "September"
    | "October"
    | "November"
    | "December"
  )[];
}

export interface SetupTeamConfig {
  team: Team;
  dates: DatesConfig;
}

export const setupTeamConfigs: SetupTeamConfig[] = [
  {
    team: {
      name: "Team A",
      captain: "Les Healey",
      members: [
        "Neil Duke",
        "Paul Hibbert",
        "Duncan Thomas",
        "Dave Brown Jr",
        "Lee Smith",
      ],
    },
    dates: {
      week: "THIRD",
      months: ["April", "August", "December"],
    },
  },
  {
    team: {
      name: "Team B",
      captain: "Raynor Manuel",
      members: [
        "Nick Holloway",
        "Johnathan Farzmand",
        "Wayne Sewell",
        "Vladyslav Chechotkin",
        "Robert Prentice",
      ],
    },
    dates: {
      week: "FIRST",
      months: ["January", "May", "September"],
    },
  },
  {
    team: {
      name: "Team C",
      captain: "Warrick Stanley",
      members: [
        "Dave Weston",
        "Paul Dyer",
        "Paul O'Connell",
        "Graham Thomas",
        "Jeremy Hughes",
        "Greg Milburn",
      ],
    },
    dates: {
      week: "THIRD",
      months: ["January", "May", "September"],
    },
  },
  {
    team: {
      name: "Team D",
      captain: "Peter Dawson",
      members: [
        "John Allen",
        "Adam Shepherdly",
        "Dan Lewin",
        "David Bealing",
        "Robert Deacon",
        "Andrew Miline",
      ],
    },
    dates: {
      week: "FIRST",
      months: ["February", "June", "October"],
    },
  },
  {
    team: {
      name: "Team E",
      captain: "Russell Sharp",
      members: [
        "Alan Vowler",
        "Colin Jackson",
        "Chris Jay",
        "Ricky De Silva",
        "Roger White",
      ],
    },
    dates: {
      week: "THIRD",
      months: ["February", "June", "October"],
    },
  },
  {
    team: {
      name: "Team F",
      captain: "Richard Escott",
      members: ["Peter Hooley", "Peter Vernon-Kell", "Tim Escott", "Varinder Dhir"],
    },
    dates: {
      week: "FIRST",
      months: ["March", "July", "November"],
    },
  },
  {
    team: {
      name: "Team G",
      captain: "Eric Duffell",
      members: ["Bernard Cole", "Alan Marchetti", "Roy O'Gorman", "Tony Reeves", "Kim Reeves"],
    },
    dates: {
      week: "THIRD",
      months: ["March", "July", "November"],
    },
  },
  {
    team: {
      name: "Team H",
      captain: "Martin Sullivan",
      members: [
        "Julian O'Neill",
        "Dean Cameron",
        "Simon Trustam",
        "Matthew Trustam",
        "Jonathan King",
      ],
    },
    dates: {
      week: "FIRST",
      months: ["April", "August", "December"],
    },
  },
];
